import { render, staticRenderFns } from "./openInvoice.vue?vue&type=template&id=bedacddc&scoped=true&"
import script from "./openInvoice.vue?vue&type=script&lang=js&"
export * from "./openInvoice.vue?vue&type=script&lang=js&"
import style0 from "./openInvoice.vue?vue&type=style&index=0&id=bedacddc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedacddc",
  null
  
)

export default component.exports